import type React from 'react';
import { twMerge } from 'tailwind-merge';

interface Step {
  label: string;
  prompt: string;
}

interface StepCalloutProps {
  steps: Step[];
  className?: string;
}

const StepCallout = ({
  steps,
  className,
}: StepCalloutProps): React.JSX.Element => {
  if (!steps.length) return <></>;

  return (
    <div className={twMerge('flex flex-col', className)}>
      {steps.map((step, index) => {
        const isLast = index === steps.length - 1;

        return (
          <div key={index} className="flex flex-col">
            <div className="flex items-center gap-3">
              <div className="flex size-6 shrink-0 items-center justify-center rounded-full bg-gray-100 text-xs font-semibold text-gray-900">
                {index + 1}
              </div>
              <div className="flex-1 rounded-md bg-gray-100 px-3 py-2">
                <h3 className="text-xs font-medium leading-4 text-gray-500">
                  {step.label}
                </h3>
                <p className="text-base text-gray-900">{step.prompt}</p>
              </div>
            </div>

            {!isLast && (
              <div
                className="ml-[11px] h-4 w-px bg-gray-300"
                aria-hidden="true"
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepCallout;
